let $ = require("jquery");
let _ = require("underscore");
let DbRecorder = require("../recorder/DbRecorder.js");
import i18n from "../utils/i18n";
import POS from "../POS.js";

let Backbone = require("backbone");
let BillPayView = require("../templates/cashier/BillPayView.handlebars");
import ThirdPartyBillView from "../view/comp/ThirdPartyBillView.js";
import ModalView from "../view/comp/ModalView.js";
let PaymentCollection = require("../collection/PaymentCollection.js");

let main = function () {
    //var status = new Backbone.Model({status:"Create"});
    var billPayService = {
        getStatus: function () {
            return status;
        },
        refundPaid: function (notification) {
            var self = this, bill = notification.get('bill');
            console.log("payload=" + notification.bill);
            var params = {
                bill: bill,
                refundAmount: bill.transaction.totalRefund,
                transNo: notification.get('transNo'),
                refundSuccess: notification.get("payStatus") == "RefundSuccess",
                channel: notification.get('channel') == "WEIXIN" ? "wx" : "alipay",
                payMode: notification.get('channel') == "WEIXIN" ? i18n.msg('pos.cashier.weixinPayment') : i18n.msg('pos.settings.license.purchase.confirm.payment.alipay')
            };
            var billPayView = $(BillPayView(params));
            console.log("table id is " + bill.table.id);
            var table = POS.getTable(bill.table.id);
            var billDetails = table.getActiveBillCollection().get(bill.id);
            var bill = DbRecorder.convert2JSON(billDetails);
            bill.table = table.toJSON();
            var model = new Backbone.Model();
            var thirdPartyBillView = new ThirdPartyBillView(
                {
                    el: billPayView,
                    bill: bill,
                    model: model
                });
            var thirdPartyBillViewModal = new ModalView({
                body: thirdPartyBillView.el,
                hideHeader: true,
                hideFooter: true
            }).render();
            thirdPartyBillViewModal.$el.find(".modal-content").addClass("billPaidModal");
            thirdPartyBillViewModal.listenToOnce(model, "change:close", function () {
                console.log("close thirdPartyBillView");
                thirdPartyBillViewModal.close();
            });
        },
        paidSuccess: function (notification) {
            var self = this, bill = notification.get('bill');
            console.log("payload=" + notification);
            var params = {
                bill: bill,
                amount: bill.transaction.totalAmount,
                paidSuccess: notification.get("payStatus"),
                transNo: notification.get('transNo'),
                channel: notification.get('channel') == "WEIXIN" ? "wx" : "alipay",
                payMode: notification.get('channel') == "WEIXIN" ? i18n.msg('pos.cashier.weixinPayment') : i18n.msg('pos.settings.license.purchase.confirm.payment.alipay')
            };
            var billPayView = $(BillPayView(params));
            console.log("table id is " + bill.table.id);
            var table = POS.getTable(bill.table.id);
            var billDetails = table.getActiveBillCollection().get(bill.id);
            var _payments = new PaymentCollection(bill.payments || []);
            billDetails.set({payments: _payments});
            bill = DbRecorder.convert2JSON(billDetails);
            bill.table = table.toJSON();
            var model = new Backbone.Model();
            var thirdPartyBillView = new ThirdPartyBillView(
                {
                    el: billPayView,
                    bill: bill,
                    model: model
                });
            var thirdPartyBillViewModal = new ModalView({
                body: thirdPartyBillView.el,
                hideHeader: true,
                hideFooter: true
            }).render();
            thirdPartyBillViewModal.$el.find(".modal-content").addClass("billPaidModal");
            thirdPartyBillViewModal.listenToOnce(model, "change:close", function () {
                console.log("close thirdPartyBillView");
                thirdPartyBillViewModal.close();
                Backbone.history.navigate("table/" + table.id, {trigger: true});
            });
        }
    };
    return billPayService;
};
let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/service/BillPayService.js